import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import PostControls from 'flarum/forum/utils/PostControls';

import ReportPostModal from './components/ReportPostModal';

export default function addReportControl() {
  extend(PostControls, 'userControls', function (items, post) {
    items.remove('flag');

    if (!app.session.user || post.contentType() !== 'comment') return;

    if (post.attribute('hasYingtaoReported')) {
      items.add(
        'yingtaoReport',
        <Button icon="fas fa-flag" disabled>
          {app.translator.trans('yingtao-forum-homepage.forum.report.already_reported')}
        </Button>,
        -10
      );
      return;
    }

    if (!post.attribute('canYingtaoReport')) return;

    items.add(
      'yingtaoReport',
      <Button icon="far fa-flag" onclick={() => app.modal.show(ReportPostModal, { post })}>
        {app.translator.trans('yingtao-forum-homepage.forum.report.button')}
      </Button>,
      -10
    );
  });
}
